import DataLoadError, {
  DataLoadDefaultErrors,
} from "../../../utils/data-load-error/data-load-error";

export enum GpsPlanEntryRecordsErrorType {
  GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
}

export type GpsPlanEntryRecordsErrorGatewayTimeout = DataLoadError<
  GpsPlanEntryRecordsErrorType.GATEWAY_TIMEOUT,
  {}
>;

type GpsPlanEntryRecordsError =
  | GpsPlanEntryRecordsErrorGatewayTimeout
  | DataLoadDefaultErrors;

export default GpsPlanEntryRecordsError;
